import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const ArrowUpLeftContained = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 24 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          d="M9.72414 7.97177C9.31162 7.93427 8.94682 8.23827 8.90931 8.65079C8.87181 9.0633 9.17582 9.42811 9.58833 9.46561L9.72414 7.97177ZM14.8125 9.18744L15.5594 9.11954C15.5267 8.75898 15.241 8.4733 14.8804 8.44052L14.8125 9.18744ZM14.5344 14.4116C14.5719 14.8241 14.9367 15.1281 15.3492 15.0906C15.7617 15.0531 16.0657 14.6883 16.0282 14.2758L14.5344 14.4116ZM8.65715 14.2822C8.36426 14.575 8.36426 15.0499 8.65715 15.3428C8.95004 15.6357 9.42492 15.6357 9.71781 15.3428L8.65715 14.2822ZM9.58833 9.46561L14.7446 9.93436L14.8804 8.44052L9.72414 7.97177L9.58833 9.46561ZM14.0656 9.25534L14.5344 14.4116L16.0282 14.2758L15.5594 9.11954L14.0656 9.25534ZM14.2822 8.65711L8.65715 14.2822L9.71781 15.3428L15.3429 9.71777L14.2822 8.65711ZM20.25 12C20.25 16.5563 16.5563 20.25 12 20.25V21.75C17.3848 21.75 21.75 17.3848 21.75 12H20.25ZM12 20.25C7.44365 20.25 3.75 16.5563 3.75 12H2.25C2.25 17.3848 6.61522 21.75 12 21.75V20.25ZM3.75 12C3.75 7.44365 7.44365 3.75 12 3.75V2.25C6.61522 2.25 2.25 6.61522 2.25 12H3.75ZM12 3.75C16.5563 3.75 20.25 7.44365 20.25 12H21.75C21.75 6.61522 17.3848 2.25 12 2.25V3.75Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default ArrowUpLeftContained
